export const urlToFilename = (url) => decodeURIComponent(new URL(url).pathname.split('/').pop());
